import React, { FC } from 'react';

import useMatchMediaQuery from 'Shared/Hooks/useMediaQuery';

import Loadable from 'Shared/Loadable';

import { RightProps } from '../../types';

const Right: FC<RightProps> = props => {
  const { matches: isDesktop } = useMatchMediaQuery('md');

  return isDesktop ? (
    <Loadable
      module={() =>
        import(/* webpackChunkName: "mainmenu-right-desktop" */ './Desktop')
      }
      {...props}
    />
  ) : (
    <Loadable
      module={() =>
        import(/* webpackChunkName: "mainmenu-right-mobile" */ './Mobile')
      }
      {...props}
    />
  );
};

export default Right;
